import React from 'react';
import ZeroToOne from '../components/Connect/Zero-to-One/ZeroToOne';

const $ = typeof window !== `undefined` ? require('jquery') : null;

const responsiveValue = {
  lg: {
    breakpoint: {
      max: Number.MAX_SAFE_INTEGER,
      min: 1201,
    },
    items: 3,
    partialVisibilityGutter: 40,
    slidesToSlide: 3,
  },
  md: {
    breakpoint: {
      max: 1200,
      min: 769,
    },
    items: 2,
    partialVisibilityGutter: 30,
    slidesToSlide: 2,
  },
  sm: {
    breakpoint: {
      max: 768,
      min: 0,
    },
    items: 1,
    partialVisibilityGutter: 30,
    slidesToSlide: 1,
  },
};

function index() {
  return <ZeroToOne />;
}

export default index;
